import React from 'react';
import useUser from '../hooks/useUser';
import ServerUserModules from '../masters/server/UserModules';

const UserModules = () => {
    const { userRole } = useUser();
    const role = userRole || localStorage.getItem('role') || '';
    const roleLower = role?.toLowerCase() || '';

    return <ServerUserModules />;
};

export default UserModules;
